import React, { Component } from 'react';

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";
import { Captcha } from 'primereact/captcha';
import TextBox from "../../../../generic_components/components/input_boxes/TextBox";
import LoadingPgTemplate from "../../../../generic_components/view/LoadingPgTemplate";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../functions/generic_functions";

//router
import { withRouter, NavLink } from 'react-router-dom';

//static routes
import {
    cari_home_pg_url,
    cari_api_create_account_url,
} from "../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariActiveVerifiedLoginUserData,
    setCariActiveUserData,
    openCariModal
} from "../../../../redux/actions/indexActions";

//redux mapper
const mapDispatchToProps = dispatch => {
    return {
        setCariActiveVerifiedLoginUserData: (user_data) => {
            dispatch(setCariActiveVerifiedLoginUserData(user_data))
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
    };
};

class CariLoginCreateAccountVerificationPg extends Component {

    state = {
        fetchApiInProgress: false,
        reCaptchaVerified: false, //todo later set to false

        postData: {
            email: "",
            verification_code: "",
            first_name: "",
            last_name: "",
        }
    }

    constructor(props) {
        super(props);

        //refs
        this.captchaRef = React.createRef();

        //captcha response
        this.handleOnClickCaptchaResponse = this.handleOnClickCaptchaResponse.bind(this);
        this.handleOnExpireCaptchaResponse = this.handleOnExpireCaptchaResponse.bind(this);

        //click handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);
        this.handleOnClickVerifyCodeAndCreateAccount = this.handleOnClickVerifyCodeAndCreateAccount.bind(this);

        //reset captcha
        this.resetCaptcha = this.resetCaptcha.bind(this);
    }

    handleOnClickCaptchaResponse() {
        this.setState({
            reCaptchaVerified: true
        })
    }

    handleOnExpireCaptchaResponse() {
        this.setState({
            reCaptchaVerified: false
        })
    }

    resetCaptcha() {
        this.captchaRef.current.reset();
        this.setState({
            reCaptchaVerified: false
        })
    }

    //handles change event on set form input data to state
    handleOnChangeSetParentState(value, nameKey) {
        var copyPostData = cloneObject(this.state.postData);

        copyPostData[nameKey] = value;

        //set data
        this.setState({
            postData: copyPostData,
        });
    }

    /*
        post parameters {
            email,
            verification_code,
            first_name,
            last_name,
        }

        return data {
            status => true/false
            message {
                email,
                token,
                first_name,
                last_name,
                accountExists: true/false
                validated: true/false
            }
        }
    */
    handleOnClickVerifyCodeAndCreateAccount() {

        var currentVerificationCode = this.state.postData.verification_code;
        var copyPostData = cloneObject(this.state.postData);
        
        if (isEmpty(copyPostData.first_name) || isEmpty(copyPostData.last_name)) {
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Please fill in all the required fields.",
                callBackFuncOnOk: () => {
                    this.resetCaptcha();
                }
            });
        }
        //invalid verification code format
        else if (currentVerificationCode.length !== 8) {
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Invalid Verification Code, please try again.",
                callBackFuncOnOk: () => {
                    this.resetCaptcha();
                }
            });
        }
        //send request
        else {
            var form_data = new FormData();

            //add form data
            for (var postDataKey in copyPostData) {
                form_data.append(postDataKey, copyPostData[postDataKey]);
            }

            //shows loading icon
            this.setState({
                fetchApiInProgress: true
            })

            //post request to create account
            fetch(cari_api_create_account_url, {
                method: 'POST',
                body: form_data,
                headers: {
                    'Accept': 'application/json',
                }
            }).then((response) => {
                //only continue fetch if mounted
                if (this.state.mounted) {
                    var responseHttpCode = response.status;
                    //good request
                    if (responseHttpCode === 200) {
                        return response.json();
                    }
                    //bad request
                    else {
                        //closes loading icon on finish api
                        this.setState({
                            fetchApiInProgress: false
                        })

                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "Bad Request, please try again.",
                            callBackFuncOnOk: () => {
                                this.resetCaptcha();
                            }
                        });
                    }
                }
            }).then(json => {

                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status
                    && !isEmpty(JSON.parse(json.message))) {
                    var json_data = JSON.parse(json.message);

                    //closes loading icon on finish api
                    this.setState({
                        fetchApiInProgress: false
                    })

                    var accountExists = json_data.accountExists;
                    var validated = json_data.validated;

                    //if the account does not exist, popup modal error message
                    if (!accountExists) {
                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "The requested account does not exist. Please create a new account.",
                            callBackFuncOnOk: () => {
                                //redirect to cari login page
                                this.props.history.push(cari_home_pg_url);
                            }
                        });
                    }
                    //if the verification failed, popup modal error message
                    else if (!validated) {
                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "Incorrect Validation Code, Please try again.",
                            callBackFuncOnOk: () => {
                                //redirect to cari login page
                                this.props.history.push(cari_home_pg_url);
                            }
                        });
                    }
                    else {
                        //save the email and returned token to the redux store
                        var currentEmail = json_data.email;
                        var currentToken = json_data.token;
                        var currentFirstName = json_data.first_name;
                        var currentLastName = json_data.last_name;

                        this.props.setCariActiveVerifiedLoginUserData({
                            "email": currentEmail,
                            "token": currentToken,
                        })
                        this.props.setCariActiveUserData({
                            "first_name": currentFirstName,
                            "last_name": currentLastName
                        });

                        //redirect to cari home page
                        this.props.history.push(cari_home_pg_url);
                    }
                }
                //if api returns no data
                else {
                    //closes loading icon on finish api
                    this.setState({
                        fetchApiInProgress: false
                    })

                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Failed to retrieve data, please try again.",
                        callBackFuncOnOk: () => {
                            this.resetCaptcha();
                        }
                    });
                }
            })
                //if api is not found
                .catch((error) => {
                    console.log(error);

                    //closes loading icon on finish api
                    this.setState({
                        fetchApiInProgress: false
                    })

                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Something went wrong, please try again",
                        callBackFuncOnOk: () => {
                            this.resetCaptcha();
                        }
                    });
                })
        }
    }

    componentDidMount() {
        //get email from parameter of match and set it for state
        var email_from_param = this.props.match.params.email

        var copyPostData = cloneObject(this.state.postData);
        copyPostData.email = email_from_param;

        //only load recaptcha after page loads
        this.setState({
            mounted: true,
            pageLoaded: true,
            postData: copyPostData
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() {
        return (
            <div className={"login_page_format " + ((!this.state.pageLoaded) ? "display_none" : "")}>
                <div className="login_page_layout"> 
                    <img className="beedie_logo_padding_style" src="/new_beedie_logo.png"></img>
                </div>

                <br/>
                
                <div className="login_page_layout"> 
                    <p className="login_text_style">
                        Continuing Position Application <br/> Create Account
                    </p>
                </div>

                <div className="login_page_layout"> 
                    <TextBox
                        value={this.state.postData.first_name}
                        name={"first_name"}
                        placeholder={"First Name"}
                        required={true}
                        onChangeSetParentState={this.handleOnChangeSetParentState}
                        maxLength={64}
                        className={"input_box_format"}
                    />
                </div>

                <br/>
                       
                <div className="login_page_layout">    
                    <TextBox
                        value={this.state.postData.last_name}
                        name={"last_name"}
                        placeholder={"Last Name"}
                        required={true}
                        onChangeSetParentState={this.handleOnChangeSetParentState}
                        maxLength={64}
                        className={"input_box_format"}
                    />    
                </div>

                <br/>

                <div className="login_page_layout">            
                    <TextBox
                        value={this.state.postData.verification_code}
                        name={"verification_code"}
                        placeholder={"Verification Code"}
                        required={true}
                        onChangeSetParentState={this.handleOnChangeSetParentState}
                        maxLength={8}
                        className={"input_box_format"}
                    />
                </div>

                <div className="login_page_layout text_align_center">
                    <NavLink to={cari_home_pg_url}>
                        Did not get your verification email?
                        <br/><br/>
                        <u className={"sfu_red"}>
                            Click here to try again
                        </u>
                    </NavLink>
                </div>

                <br/>

                <div className={(this.state.fetchApiInProgress) ? "display_none" : ""}>
                    <div className="login_page_layout"> 
                        <div className={"captcha_format"}>
                            {this.state.pageLoaded ?
                                <Captcha
                                    ref={this.captchaRef}
                                    //siteKey="6LeyBH8UAAAAADPnB0nxywQOnr8dH-oJiSPYuqYa"
                                    siteKey="6Le2YB4oAAAAABT_C48jYaOvDJKag5h7Qa6C8Lfo"
                                    onResponse={this.handleOnClickCaptchaResponse}
                                    onExpire={this.handleOnExpireCaptchaResponse}
                                />
                                : null
                            }
                        </div>
                    </div>
                  
                    <div className="login_page_layout"> 
                        <CustomButton
                            disabled={!this.state.reCaptchaVerified}
                            label={"Create Account"}
                            className={"p-button-sfu-red cari_position_action_btn_size"}
                            btnRaised={true}
                            onClickSetParentState={this.handleOnClickVerifyCodeAndCreateAccount}
                        />
                    </div>
                </div>

                <div className="login_page_layout"> 
                    <p className="login_issue_text">Should you have any questions or issues, please contact the Dean's Office, Beedie School of Business, at aacoord@sfu.ca</p>
                </div>

                {(this.state.fetchApiInProgress) ?
                    <LoadingPgTemplate />
                    : null}
            </div>
        );
    }
}
export default connect(null, mapDispatchToProps)(withRouter(CariLoginCreateAccountVerificationPg));





